import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { useMediaQuery } from './MobileOptimiseHook';
import Stack from '@mui/material/Stack';
import { Box, Grid } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { CustomRoundButton } from 'Layout/CustomButton';
import { Link } from 'react-router-dom';
import { componentSelectedSliceValue } from 'app/slice/componentSelectedSlice';
import { useSelector } from 'react-redux';

export default function CustomFooter() {
    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const isLaptop = window.innerWidth < 2560 && window.innerWidth > 1030;
    //to know what component was clicked and handle UI change on scroll (HomePage.js)
    let component = useSelector(componentSelectedSliceValue);

    return (
        <AppBar
            elevation={0}
            position={'fixed'}
            sx={{
                backgroundColor: 'transparent',
                border: 'none',
                width: '100%',
                top: isMobile ? '92%' : '95%',
                // paddingRight:'20px'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    // justifyContent: 'flex-end',
                    // backgroundColor: 'red',
                }}
            >
                {isMobile ? null :
                 <Grid
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        width: '50%',
                    }}
                >
                    {' '}
                    <Toolbar>
                        <Stack
                            sx={{
                                textDecoration: 'none',
                                color: 'black',
                            }}
                            direction='row'
                            alignItems='center'
                            gap={2}
                        >
                            {' '}
                            <CopyrightIcon
                                sx={{ fontSize: isDesktop ? '12px' : '10px' }}
                            />
                            <Typography
                                sx={{ fontSize: isDesktop ? '12px' : '10px' }}
                            >
                                {''}The 7 Day Project 2022
                            </Typography>
                        </Stack>
                    </Toolbar>
                </Grid>
                }
               

                {component.value === 'help' ? null : (
                    <Grid
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: isMobile? '100%': '50%',
                            paddingRight: '15px',
                            paddingBottom: '15px',
                        }}
                    >
                        {' '}
                        <Link
                            style={{ color: 'white' }}
                            to='/help'
                            // onClick={() =>
                            //     // @ts-ignore
                            //     (window.location = 'tel://+61417139641')
                            // }
                        >
                            {' '}
                            <CustomRoundButton
                                sx={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    opacity: 0.7,
                                }}
                            >
                                <HelpIcon
                                    sx={{
                                        color: 'white',
                                        fontSize: isLaptop ? '30px' : '50px',
                                    }}
                                    fontSize='large'
                                />
                            </CustomRoundButton>{' '}
                        </Link>
                    </Grid>
                )}
            </Box>
        </AppBar>
    );
}
